export type WhatsappChannel = {
  status: string
  display_address: string | null
} | null | undefined

export function whatsappConnectionUi(
  channel: WhatsappChannel,
  plan?: string | null,
) {
  const status = channel?.status ?? null
  const live = status === "connected" || status === "degraded"

  const statusLabel =
    status === "connected"
      ? "conectado"
      : status === "degraded"
        ? "degradado"
        : status === "disconnected"
          ? "desconectado"
          : status || "no conectado"

  const statusClass =
    status === "connected"
      ? "text-green-600"
      : status === "degraded"
        ? "text-yellow-500"
        : "text-muted-foreground"

  return {
    live,
    showFeatureToggles: live,
    statusLabel,
    statusClass,
    canDisconnect: live,
    showUpgradeLock: plan === "free" && !live,
    primaryAction: live ? "reconnect" : "connect",
  } as const
}
